import React from "react";

import DeviceOverview from "../../components/DeviceOverview";

const DevicesRoute = () => {
    return (
        <div className="container">
            <DeviceOverview></DeviceOverview>
        </div>
    );
};

export default DevicesRoute;
